import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { PriceDisplayComponent } from "./price-display.component";

@NgModule({
	imports: [CommonModule],
	providers: [CurrencyPipe],
	declarations: [PriceDisplayComponent],
	exports: [PriceDisplayComponent]
})
export class PriceDisplayModule {}
